// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__R1kPs","fs":"Modal_fs__UNTIL","docked":"Modal_docked__urOli"};